import React from 'react';
import { Tab as MaterialTab } from '@material-ui/core';
import { useStyles } from './Tab.styles';

export interface Props {
  disabled?: boolean;
  qaId?: string;
  label?: React.ReactNode;
  ariaLabel?: string;
  icon?: string | React.ReactElement;
  children?: React.ReactElement;
  className?: string;
  selected?: boolean;
  wrapped?: boolean;
  value?: any;
}

const Tab: React.FC<Props> = (props: Props) => {
  const { qaId, ariaLabel = 'tab', ...restProps } = props;
  const classes = useStyles();

  return (
    <MaterialTab
      data-qa-id={qaId}
      classes={{
        root: classes.root,
        selected: classes.selected,
      }}
      aria-label={ariaLabel}
      {...restProps}
    />
  );
};

export default Tab;
